import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import MfprintingstatusEditForm from './MfprintingstatusEditForm';
import MfprintingstatusList from './MfprintingstatusList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import MfprintingstatusListView from './MfprintingstatusListView'


export default function MfprintingstatusDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.mfprintingstatusDashboard);
  const [ mfprintingstatusId, setMfprintingstatusId] = React.useState('');
  const [reloadMfprintingstatusList, setReloadMfprintingstatusList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <MfprintingstatusEditForm 
            setReloadMfprintingstatusList={setReloadMfprintingstatusList}
            mfprintingstatusId={mfprintingstatusId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <MfprintingstatusListView 
                      setMfprintingstatusId = {setMfprintingstatusId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
